import React from 'react';
import { HardHat, MapPin } from 'lucide-react';
import { formatShortDate } from '../../utils/date-utils';

export default function SchedulingInfo({ job }) {
  return (
    <div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: 'var(--text-primary)',
        marginBottom: '16px'
      }}>
        Scheduling Information
      </h3>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        {/* Sold Date */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'flex-start'
        }}>
          <span style={{
            fontSize: '13px',
            color: 'var(--text-tertiary)',
            minWidth: '140px',
            fontWeight: '600'
          }}>
            Sold Date:
          </span>
          <span style={{
            fontSize: '14px',
            color: 'var(--text-primary)',
            fontWeight: '600'
          }}>
            {job.soldDate ? formatShortDate(job.soldDate) : 'Not set'}
          </span>
        </div>

        {/* Scheduled Date */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'flex-start'
        }}>
          <span style={{
            fontSize: '13px',
            color: 'var(--text-tertiary)',
            minWidth: '140px',
            fontWeight: '600'
          }}>
            Scheduled Date:
          </span>
          <span style={{
            fontSize: '14px',
            color: job.scheduledDate ? 'var(--text-primary)' : 'var(--text-tertiary)',
            fontWeight: job.scheduledDate ? '600' : '400'
          }}>
            {job.scheduledDate ? formatShortDate(job.scheduledDate) : 'Not scheduled'}
          </span>
        </div>

        {/* Assigned Crew */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'flex-start'
        }}>
          <span style={{
            fontSize: '13px',
            color: 'var(--text-tertiary)',
            minWidth: '140px',
            fontWeight: '600'
          }}>
            Assigned Crew:
          </span>
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            color: job.assignedCrew ? 'var(--text-primary)' : 'var(--text-tertiary)',
            fontWeight: job.assignedCrew ? '600' : '400'
          }}>
            {job.assignedCrew ? <><HardHat size={13} strokeWidth={2.25} /> {job.assignedCrew}</> : 'Not assigned'}
          </span>
        </div>

        {/* Contract Number */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'flex-start'
        }}>
          <span style={{
            fontSize: '13px',
            color: 'var(--text-tertiary)',
            minWidth: '140px',
            fontWeight: '600'
          }}>
            Contract Number:
          </span>
          <span style={{
            fontSize: '14px',
            color: 'var(--text-primary)',
            fontWeight: '600'
          }}>
            #{job.contractNumber || 'Not set'}
          </span>
        </div>

        {/* Location */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'flex-start'
        }}>
          <span style={{
            fontSize: '13px',
            color: 'var(--text-tertiary)',
            minWidth: '140px',
            fontWeight: '600'
          }}>
            Location:
          </span>
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            color: 'var(--text-primary)'
          }}>
            <MapPin size={13} strokeWidth={2.25} /> {job.name || 'Not specified'}
          </span>
        </div>
      </div>
    </div>
  );
}